// extracted by mini-css-extract-plugin
module.exports = {"root":"CardContent_root__zouMk","extraPadding":"CardContent_extraPadding__uEbL2"};